/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { PaymentApiConfiguration } from '../payment-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PamInstallmentRequestDtoDto } from '../models/pam-installment-request-dto-dto';
import { PamInstallmentResponseDto } from '../models/pam-installment-response-dto';


/**
 * the PamCommandUpdateInstallment API
 */
@Injectable({
  providedIn: 'root',
})
export class PamCommandUpdateInstallmentService extends BaseService {
  constructor(
    config: PaymentApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation installmentUpdate
   */
  static readonly InstallmentUpdatePath = '/installment/{id}';

  /**
   * Update installment.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `installmentUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  installmentUpdate$Response(params: {

    /**
     * UID of the installment
     */
    id: string;
    body: PamInstallmentRequestDtoDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PamInstallmentResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, PamCommandUpdateInstallmentService.InstallmentUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PamInstallmentResponseDto>;
      })
    );
  }

  /**
   * Update installment.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `installmentUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  installmentUpdate(params: {

    /**
     * UID of the installment
     */
    id: string;
    body: PamInstallmentRequestDtoDto
  },
  context?: HttpContext

): Observable<PamInstallmentResponseDto> {

    return this.installmentUpdate$Response(params,context).pipe(
      map((r: StrictHttpResponse<PamInstallmentResponseDto>) => r.body as PamInstallmentResponseDto)
    );
  }

}
